import React from 'react';
import classes from './DynamicInput.css';
import InputMask from 'react-input-mask';

const DynamicInput = (props) => {

    let inputElement = null;

    const uiIdentificationTypes = props.uiIdentificationTypes;

    const inputClass = [classes.InputElement];

    inputClass.push(classes[props.styleClasses]);

    if(!uiIdentificationTypes.isValid && uiIdentificationTypes.touched) {
        inputClass.push(classes.Invalid);
    }

    switch (uiIdentificationTypes.componentType) {
        case ('tier1') :
            inputElement = <input
                                id={uiIdentificationTypes.id}
                                //ref={ref}
                                name={uiIdentificationTypes.id}
                                type={uiIdentificationTypes.inputType}
                                className={inputClass.join(' ')}
                                //value={uiIdentificationTypes.value || ''}
                                onChange={props.handleOnChange}
                                onFocus={props.handleOnFocus}
                                value={props.value}
                                tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
                                {...uiIdentificationTypes.properties}
                            />;
            break;
        case ('tier2') :
            inputElement = <InputMask
                                id={uiIdentificationTypes.id}
                                name={uiIdentificationTypes.id}
                                mask={uiIdentificationTypes.mask}
                                maskChar={uiIdentificationTypes.maskChar}
                                type={uiIdentificationTypes.inputType}
                                value={uiIdentificationTypes.value}
                                alwaysShowMask
                                className={inputClass.join(' ')}
                                onChange={props.handleOnChange}
                                onFocus={props.handleOnFocus}
                                {...uiIdentificationTypes.properties}
                            >
                                {inputProps => <input {...inputProps} {...uiIdentificationTypes.properties} />}
                            </InputMask>
            break;
        case ('dob'):
            inputElement = <input
                                id={uiIdentificationTypes.id}
                                //ref={ref}
                                name={uiIdentificationTypes.id}
                                type="date"
                                className={inputClass.join(' ')}
                                //value={uiIdentificationTypes.value || ''}
                                onChange={props.handleOnChange}
                                onFocus={props.handleOnFocus}
                                value={props.value}
                                tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
                                {...uiIdentificationTypes.properties}
                            />;
            break;
        case ('email'):
            inputElement = <input
                                type={"email"}
                                className={inputClass.join(' ')}
                                id={uiIdentificationTypes.id}
                                name={uiIdentificationTypes.id}
                                onChange={props.handleOnChange}
                                onFocus={props.handleOnFocus}
                                value={props.value || ''}
                                tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
                                {...uiIdentificationTypes.properties}
                            />;
            break;
        default:
            inputElement = <input
                className={classes.InputElement}
                {...props.elementConfig}
                value={props.value}
                tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0} />;
    }

    return (
        <div className={classes.Input}>
                <label className={classes.Label}>
                    <div>{uiIdentificationTypes.label}</div>
                    <div style={{verticalAlign: "baseline"}}>{props.icon}</div>
                </label>
                {inputElement}
        </div>
    );

}

export default DynamicInput;